import type { ReactNode } from 'react';

import type { LANGUAGE } from '@/types/commonConst';

import { getFeatureMessage } from '..';
import { heySynclyMessages } from './messages';

export type HeySynclyMessageKey = keyof typeof heySynclyMessages;

export const getHeySynclyMessage = (
  lang: LANGUAGE,
  key: HeySynclyMessageKey,
): ReactNode => {
  return getFeatureMessage(heySynclyMessages[key], lang);
};
